import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  redirectUrl: string;
  currentUser:any;
 
  get isLoggedIn(): boolean {
    return this.getCurrentUser();
  }
  getAuthToken():string {
    return  this.currentUser.token;
  }

  login(userId:string,token:string,maxSession:string, current:any){
      this.currentUser ={
          userId,
          token,
          maxSession,
          current
      };
      sessionStorage.setItem('currentUser',JSON.stringify(this.currentUser));
  }

  /**
   * Decides the loggedIn Status based on user data stored in LOCAL-STORAGE
   */
  private getCurrentUser():boolean{
    const storedUser = sessionStorage.getItem('currentUser');
    const isCurrentUserAvailable = storedUser ? true : false;
    this.currentUser = isCurrentUserAvailable ? JSON.parse(storedUser): null;
    return isCurrentUserAvailable;
  }
  logout(): void {
   this.currentUser = null;
   sessionStorage.removeItem('currentUser');
  }
}